import LaptopIcon from '@mui/icons-material/Laptop';
import JavascriptIcon from '@mui/icons-material/Javascript';
import HttpIcon from '@mui/icons-material/Http';
import GoogleIcon from '@mui/icons-material/Google';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import MouseIcon from '@mui/icons-material/Mouse';
import GitHub from '@mui/icons-material/GitHub';
import AdbIcon from '@mui/icons-material/Adb';
import BatteryUnknownSharpIcon from '@mui/icons-material/BatteryUnknownSharp';
import BatteryCharging90SharpIcon from '@mui/icons-material/BatteryCharging90Sharp';
import ConnectedTvSharpIcon from '@mui/icons-material/ConnectedTvSharp';
import CssSharpIcon from '@mui/icons-material/CssSharp';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import CoffeeSharpIcon from '@mui/icons-material/CoffeeSharp';
import TabletAndroidIcon from '@mui/icons-material/TabletAndroid';
import BluetoothAudioIcon from '@mui/icons-material/BluetoothAudio';
import FolderIcon from '@mui/icons-material/Folder';
import DirectionsBoatIcon from '@mui/icons-material/DirectionsBoat';
import DirectionsSubwayIcon from '@mui/icons-material/DirectionsSubway';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import FingerprintIcon from '@mui/icons-material/Fingerprint';
import FlightIcon from '@mui/icons-material/Flight';
import FourKIcon from '@mui/icons-material/FourK';
import HdIcon from '@mui/icons-material/Hd';
import InstagramIcon from '@mui/icons-material/Instagram';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import NavigationIcon from '@mui/icons-material/Navigation';
import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import YouTubeIcon from '@mui/icons-material/YouTube';
import WebhookIcon from '@mui/icons-material/Webhook';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import TwoKPlusIcon from '@mui/icons-material/TwoKPlus';
import TrafficIcon from '@mui/icons-material/Traffic';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';




export const icons = 
[
	<LaptopIcon sx={{padding:0, fontSize:'2.5em'}} />,
	<JavascriptIcon sx={{padding:0, fontSize:'2.5em'}} />,
	<HttpIcon sx={{padding:0, fontSize:'2.5em'}} />,
	<GoogleIcon sx={{padding:0, fontSize:'2.5em'}} />,
	<KeyboardIcon sx={{padding:0, fontSize:'2.5em'}} />,
	<HeadphonesIcon sx={{padding:0, fontSize:'2.5em'}} />,
	<MouseIcon sx={{padding:0, fontSize:'2.5em'}} />,
	<GitHub sx={{padding:0, fontSize:'2.5em'}} />,
	<AdbIcon sx={{padding:0, fontSize:'2.5em'}} />,
	<BatteryUnknownSharpIcon sx={{padding:0, fontSize:'2.5em'}} />,
	<BatteryCharging90SharpIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <ConnectedTvSharpIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <CssSharpIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <LanguageSharpIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <CoffeeSharpIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <TabletAndroidIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <BluetoothAudioIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <FolderIcon sx={{padding:0, fontSize:'2.5em'}}  />,
   
  <DirectionsBoatIcon sx={{padding:0, fontSize:'2.5em'}}  />,
  <DirectionsSubwayIcon sx={{padding:0, fontSize:'2.5em'}} />,
 	<DirectionsBikeIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <FingerprintIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <FlightIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <FourKIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <HdIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <InstagramIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <InsertEmoticonIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <LinkedInIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <NavigationIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <TwoWheelerIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <YouTubeIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <WebhookIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <WhereToVoteIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <TwoKPlusIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <TrafficIcon sx={{padding:0, fontSize:'2.5em'}} />,
  <SportsEsportsIcon sx={{padding:0, fontSize:'2.5em'}} />,

];